import styled from "styled-components";
import {JackpotBetWinHighlightDefaultBox} from "./jackpot-bet-win-highlight.default.box";

export const JackpotBetWinHighlightCasino777Box = styled(JackpotBetWinHighlightDefaultBox)`
    box-shadow: 
        0px 0px 20px 0px #0EA79B80 inset,
        0px 0px 30px 2px #0EA79BBF,
        0px 0px 40px 0px #FFE60166 inset;

    background-color: #361018; 
    background-image: radial-gradient( #63464d 20%, #361018 50%);

    border: 2px solid #30F7E8;
`;

